import React from 'react'

import { Ul } from './styles'

import IProps from './props'

const ListRenderer = ({ items }: IProps) => (
  <Ul>
    {items.map((item) => (
      <li key={`list-item-${item}`}>{item}</li>
    ))}
  </Ul>
)

export default ListRenderer
